import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';

type Props = {
  connected?: boolean;
  sellerId?: string;
  marketplace?: string;
};

export function AmazonConnectStep({ connected = false, sellerId, marketplace = 'Amazon.in' }: Props) {
  return (
    <div className="rounded-xl border border-orange-200 bg-orange-50/50 p-5 dark:border-orange-900 dark:bg-orange-950/30">
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-orange-600 text-lg text-white" aria-hidden="true">
          a
        </span>
        <div className="flex-1">
          <h3 className="font-semibold text-slate-900 dark:text-slate-100">Connect Amazon Seller Account</h3>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
            Authorize via secure OAuth. No manual Client ID or refresh tokens required.
          </p>
          {connected ? (
            <div className="mt-3 rounded-lg border border-success-200 bg-success-50 p-3 text-sm dark:border-success-800 dark:bg-success-950">
              <p className="font-medium text-success-800 dark:text-success-200">Connected</p>
              {sellerId && <p className="mt-1 text-xs text-slate-600">Seller ID: {sellerId}</p>}
              {marketplace && <p className="text-xs text-slate-600">Marketplace: {marketplace}</p>}
            </div>
          ) : (
            <div className="mt-4 flex flex-wrap gap-2">
              <Link to="/amazon/connect">
                <Button variant="primary" className="bg-orange-600 hover:bg-orange-700">
                  Authorize Amazon
                </Button>
              </Link>
              <Button variant="secondary" size="md">Skip for now</Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
